const hrcu_motion_Block = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E7':
            return `
            <category 
                name="%{BKY_CATEGORY_MOVE}"
                id="hrcu_motion"
                colour="#fccf06" 
                secondaryColour="#fccf06">
            
                <block type="hrcu_motion_setMotorsByTime">
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_motion_setMotors">
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                
                <block type="hrcu_motion_setMotorsByLength">
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="LENGTH">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                </block>
                
                <block type="hrcu_motion_setMotorsAngle">
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_motion_stopMotorRun"/>
                <block type="hrcu_motion_setStartMotorLorR"/>
                <block type="hrcu_motion_setOneCircleSize">
                    <value name="LENGTH">
                        <shadow type="math_number">
                            <field name="NUM">20.7</field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_motion_setMotorByPercent">
                    <value name="LEFTVALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RIGHTVALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_motion_waitMotorByPercent">
                    
                    <value name="LEFTVALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="RIGHTVALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="NUM">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
            </category>
                `;
        default:
            return `
                <category 
                    name="运动" 
                    id="hrcu_motion"
                    colour="#e5a8dd" 
                    secondaryColour="#e5a8dd">
                </category>
                `;
    }
};

export default hrcu_motion_Block;
